/* eslint-disable no-use-before-define */
import React, {useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import connect from "react-redux/es/connect/connect";
import PneuFabricanteDialog from "./pneuFabricanteDialog";
import matchSorter from 'match-sorter'
import PneuModeloDialog from "./pneuModeloDialog";
import {useSelector} from "react-redux";


const filter = createFilterOptions();

// const filter = createFilterOptions({
//     matchFrom : "start",
//     stringify : option=> option.marcaId
// });

const PneuModeloSelector = ({
                                defaultValue,
                                onChange,
                                marcaId
                            }) => {
    const pneuModelos  = useSelector(state =>  state.tires.modelos && state.tires.modelos.data ? state.tires.modelos.data : []);
    const [value, setValue] = React.useState(defaultValue || '');
    const [dialogOpen, setDialogOpen] = React.useState(false)
    const [dialogValue, setDialogValue] = React.useState({
        descricao: ''
    });
    const [pmodList, setPmodList] = useState(pneuModelos || []);


    useEffect( () => {
        //console.log('pneuModelos.useEffect.defaultValue changed', defaultValue);
        const ix = pneuModelos.findIndex( f => f.id === defaultValue);
        if (ix >= 0) {
            setValue(pneuModelos[ix].descricao);
        } else {
            setValue('')
        }
        // //console.log("useEffect 1", isAddNewRecord, addNewRecord, open, isOpen);
    }, [ defaultValue ]);

    useEffect( () => {
        //console.log('pneuModelos.useEffect.marcaId changed', defaultValue);
        const ix = pneuModelos.findIndex( f => f.id === defaultValue);
        if (ix >= 0) {
            setValue(pneuModelos[ix].descricao);
        } else {
            setValue('')
        }
        // //console.log("useEffect 1", isAddNewRecord, addNewRecord, open, isOpen);
    }, [ marcaId ]);


    useEffect( () => {
            //console.log("MARCAID alterado", marcaId,pneuModelos);
          if (marcaId) {
              setPmodList(pneuModelos.filter(m => m.pneuFabricanteId === marcaId));
          } else {
              setPmodList(pneuModelos);
        }
    }, [ marcaId ]);

    console.log("modeloSelector", pneuModelos);
    console.log("modeloSelector value, marcaId, defaultValue [", value, marcaId, defaultValue,']' );
    return (
        <React.Fragment>
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        // timeout to avoid instant validation of the dialog's form.
                        setTimeout(() => {
                            setDialogOpen(true);
                            setDialogValue({
                                descricao: newValue
                                // year: '',
                            });
                            onChange(newValue);
                        });
                    } else if (newValue && newValue.inputValue) {
                        setDialogOpen(true);
                        setDialogValue({
                            title: newValue.inputValue,
                            // year: '',
                        });
                        onChange(newValue);
                    } else {
                        setValue(newValue);
                        onChange(newValue);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    if (params.inputValue !== '') {
                        filtered.push({
                            inputValue: params.inputValue,
                            descricao: `Add "${params.inputValue}"`,
                        });
                    }

                    return filtered;
                }}
                id="pneuModelo"
                options={pmodList}
                getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    if (option && option.descricao) {
                        return option.descricao;
                    } else {
                        return '';
                    }
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(option) => option.descricao}
                style={{ //width: 300
                     }}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} label="Modelo"  />
                            )}
            />
            <PneuModeloDialog open={dialogOpen}
                                  onClose={() => setDialogOpen(false)}
                                  value={dialogValue}
                                  marcaId={marcaId}

            />

        </React.Fragment>
);
}



export default (PneuModeloSelector)


